import * as React from 'react';
import Inputfields from './Components/inputfields';


function App() {
  
  
  return (
    <div className="App">
       <Inputfields/>
    </div>
  );
}

export default App;
